// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oPk-g","toggle":"styles_toggle__2E0xP","preview":"styles_preview__1xSF4"};